virtual function void write(T t);
{{#each parameters}}
  if (t.{{ ../sequenceItem.phaseEnumVariable.identifier }} == {{ name }}) begin
    {{ ../analysisPortHandle.identifier }}.write(t);
  end
{{/each}}
endfunction
